import { PortableTextObject } from 'sanity'
import { styles, ASectionVariants } from './CircularSchemas.css'
import { AppList } from '../AppList'
import { DownloadEmail } from '../DownloadEmail/DownloadEmail'
import { AppText } from '../AppText'
import { SectionHeader } from '../SectionHeader'
import { CircularSchema } from './CircularSchema/CircularSchema'
import React, { useMemo } from 'react'
import { DownloadInfoProps } from '../Button/Button'

interface CircularSchemasProps extends ASectionVariants {
	tag: string
	headline: PortableTextObject
	legendsTitle: string
	legends: any[]
	downloadInfo: DownloadInfoProps
	_key: string
	circularGraphs: any[]
}

export const CircularSchemas: React.FC<CircularSchemasProps> = ({
	tag,
	headline,
	legendsTitle,
	legends,
	downloadInfo,
	circularGraphs,
	_key,
}) => {
	const {
		wrapper,
		base,
		list,
		content,
		legendWrapperDesktop,
		legendWrapperMobile,
		formDesktop,
		legendsMobile,
		legendsDesktop,
		legendLogo,
		legendStyle,
		listItem,
	} = styles()

	// Base amount of elements if 4
	const moreElements = useMemo(() => circularGraphs.length > 4, [circularGraphs.length])

	return (
		<div className={wrapper()}>
			<section className={base()}>
				<div className={content({ moreElements })}>
					<SectionHeader title={headline} tag={tag} theme="dark" noPx fullWidth />
					<DownloadEmail _key={_key} className={formDesktop()} infos={downloadInfo} theme="dark" />
					<div className={legendWrapperDesktop()}>
						<AppText size="base" color="white">
							{legendsTitle}
						</AppText>
						<dl className={legendsDesktop()}>
							{legends.map((legend, idx) => (
								<div key={`legend-${idx}`} className={legendStyle()}>
									<dt
										className={legendLogo()}
										dangerouslySetInnerHTML={{ __html: legend.legendLogo }}
									/>
									<dd>
										<AppText color="white" className="!text-schema-legend">
											{legend.legendName}
										</AppText>
									</dd>
								</div>
							))}
						</dl>
					</div>
				</div>
				<AppList className={list({ moreElements })} itemClassName={listItem({ moreElements })}>
					{circularGraphs.map((graph, idx) => (
						<CircularSchema key={`schema-${idx}`} graph={graph} moreElements={moreElements} />
					))}
				</AppList>

				{/* FOR MOBILE */}
				<DownloadEmail
					_key={_key}
					className="lg:hidden !mt-4"
					infos={downloadInfo}
					theme="dark"
					noMt
					noPx
					center
				/>
				<div className={legendWrapperMobile()}>
					<AppText size="base" color="white">
						{legendsTitle}
					</AppText>
					<dl className={legendsMobile()}>
						{legends.map((legend, idx) => (
							<div key={`legend-${idx}`} className={legendStyle()}>
								<dt
									className={legendLogo()}
									dangerouslySetInnerHTML={{ __html: legend.legendLogo }}
								/>
								<dd>
									<AppText size="base" color="white" weight="medium">
										{legend.legendName}
									</AppText>
								</dd>
							</div>
						))}
					</dl>
				</div>
			</section>
		</div>
	)
}
